// shop-by-fabric
document.addEventListener("DOMContentLoaded", function () {
  const sliderSections = document.querySelectorAll(".slider-fix");

  sliderSections.forEach(function (section) {
    const nextButtons = section.querySelectorAll(".wt-slider__nav-next--featured");

    nextButtons.forEach(function (nextButton) {
      nextButton.classList.remove("swiper-button-lock", "swiper-button-disabled");
      nextButton.setAttribute("aria-disabled", "false");
    });
  });
});



document.addEventListener("DOMContentLoaded", () => {
  const tabContainer = document.querySelector(".parent-collections");
  const parentTabs = tabContainer?.querySelectorAll("li");
  const childItems = document.querySelectorAll(".child-collection li");
  const sliders = document.querySelectorAll(".collection-tab-products");

  let selectedTabName = null;

  // Hide all child li items
  const hideAllChildren = () => {
    childItems.forEach(item => {
      item.classList.remove("hidden");
    });
  };

  // Show child items for a specific parent
  const showChildrenForParent = (parentName) => {
    childItems.forEach(item => {
      if (item.getAttribute("data-parent") === parentName) {
        item.style.display = "list-item";
      } else {
        item.classList.add("hidden");
      }
    });
  };

  // Automatically select the first visible child
  const selectFirstVisibleChild = (parentName) => {
    const visibleChildren = Array.from(childItems).filter(
      item => item.getAttribute("data-parent") === parentName
    );

    if (visibleChildren.length > 0) {
      handleChildClick(visibleChildren[0]);
    }
  };

  // Handle child click events for collection mapping
  const handleChildClick = (child) => {
    const selectedCollection = child.getAttribute("data-collection");

    // Remove selected class from all children
    childItems.forEach(c => c.classList.remove("selected-tab"));
    child.classList.add("selected-tab");

    // Match slideshow-section by data-collection
    sliders.forEach(slider => {
      if (slider.getAttribute("data-collection") === selectedCollection) {
        slider.classList.add("show-collection");
      } else {
        slider.classList.remove("show-collection");
      }
    });
  };

  // Initial setup for default selection
  if (parentTabs?.length > 0) {
    selectedTabName = parentTabs[0].getAttribute("data-tab-name");
    selectFirstVisibleChild(selectedTabName); // auto-select first child on load
  }

  // Parent tab click handler
  parentTabs?.forEach(tab => {
    tab.addEventListener("click", () => {
      parentTabs?.forEach(t => t.classList.remove("selected-tab"));
      tab.classList.add("selected-tab");

      selectedTabName = tab.getAttribute("data-tab-name");

      hideAllChildren();
      showChildrenForParent(selectedTabName);
      selectFirstVisibleChild(selectedTabName); // auto-select first child on parent click
    });
  });

  // Child tab click handler
  childItems.forEach(child => {
    child.addEventListener("click", () => {
      handleChildClick(child);
    });
  });
});

// Product Customization
document.addEventListener('DOMContentLoaded', function () {
  // Tab Switching for customization type
  const customizationButtons = document.querySelectorAll(".customization-type");
  let activeColorHex = "white";
  if (customizationButtons) {
    customizationButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        customizationButtons.forEach((btn) => btn.classList.remove("active"));
        button.classList.add("active");

        const customizationLogo = document.querySelector(".customization-logo");
        const customizationLogoSVG = document.querySelector(".customization-logo path");
        const colorInput = document.querySelector(".color-inputs-wrapper.active");
        
        activeColorHex = colorInput ? colorInput.dataset.activeColorHex : "white";
        
        if (customizationLogo) {
          customizationLogo.style.position = "absolute";
          customizationLogo.style.top = customizationLogo.dataset.top
            ? `${customizationLogo.dataset.top}%`
            : "0px";
          customizationLogo.style.left = customizationLogo.dataset.left
            ? `${customizationLogo.dataset.left}%`
            : "0px";
          if (customizationLogoSVG) {
            customizationLogoSVG.style.fill = activeColorHex;
          }
        }

        // Toggle content tabs visibility
        document.querySelectorAll(".customization-content").forEach((content) => {
          if (content.dataset.customizationType == button.dataset.customizationType) {
            content.classList.remove("hidden");
          } else {
            content.classList.add("hidden");
          }
        });

        // Handle preview elements visibility based on type
        if (button.dataset.customizationType == "logo") {
          document.querySelectorAll(".customization-text").forEach((text) => text.classList.add("hidden"));
          if (customizationLogo) {
            customizationLogo.classList.remove("hidden");
          }
          document.querySelector(".customization-atc.proxy-atc-button").removeAttribute("disabled");
        } else {
          if (customizationLogo) {
            customizationLogo.classList.add("hidden");
          }
          document.querySelectorAll(".customization-text").forEach((text) => {
            const textSpanEl = text.querySelector(".customization-preview-text") || text;
            const hasPreviewLogo = text.querySelector(".customization-preview-logo") !== null;
            if (textSpanEl && textSpanEl.innerHTML.trim() == "" && !hasPreviewLogo) {
              text.classList.add("hidden");
            } else {
              text.classList.remove("hidden");
            }
          });
          
          const nameInputEl = document.querySelector("input[name=name]");
          const atcButton = document.querySelector(".customization-atc.proxy-atc-button");
          if (nameInputEl && atcButton) {
            if (nameInputEl.value.length == 0) {
              atcButton.setAttribute("disabled", "true");
            } else {
              atcButton.removeAttribute("disabled");
            }
          }
        }

        // Persist the Active state of color inputs
        document.querySelectorAll(".color-inputs-wrapper").forEach((input) => {
          if (activeColorHex != "white") {
            if (input.dataset.activeColorHex == activeColorHex) {
              input.classList.add("active");
              const colorName = input.querySelector(".color-name");
              if (colorName) colorName.classList.remove("hidden");
            }
          }
        });
      });
    });
  }

  // Display Color Name on click of color svgs
  const customizeColorButtons = document.querySelectorAll(".color-inputs-wrapper");

  if (customizeColorButtons.length > 0) {
    customizeColorButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();

        const isAlreadyActive = button.classList.contains("active");

        // Remove active state from all buttons
        customizeColorButtons.forEach((btn) => {
          btn.classList.remove("active");
          btn.querySelector(".color-name").classList.add("hidden");
        });

        const customizationLogo = document.querySelector(".customization-logo path");

        if (!isAlreadyActive) {
          // Activate the clicked button
          button.classList.add("active");
          button.querySelector(".color-name").classList.remove("hidden");

          const activeColor = button.dataset.activeColorHex || "white";

          // Apply active color to all customization-text elements
          document.querySelectorAll(".customization-text").forEach((text) => {
            text.style.color = activeColor;
          });
          if (customizationLogo) {
            customizationLogo.style.fill = activeColor;
          }
        } else {
          // No button is active now — reset to white
          document.querySelectorAll(".customization-text").forEach((text) => {
            text.style.color = "white";
          });
          if (customizationLogo) {
            customizationLogo.style.fill = "white";
          }
        }
      });
    });

  }

  // Customization Logic
  const nameInput = document.querySelector("input[name=name]");
  const fontFamilyInput = document.querySelector(".font-family");

  // Show B2B logo preview container on load
  document.querySelectorAll(".customization-text").forEach((text) => {
    if (text.querySelector(".customization-preview-logo")) {
      text.classList.remove("hidden");
    }
  });

  // Set the initial color of customization texts based on the active swatch
  const activeColorWrapper = document.querySelector(".color-inputs-wrapper.active");
  const initialColorHex = activeColorWrapper ? activeColorWrapper.dataset.activeColorHex : null;
  if (initialColorHex) {
    document.querySelectorAll(".customization-text").forEach((text) => {
      text.style.color = initialColorHex;
    });
  }

  // Utility to remove previous font classes
  function removeExistingFontClasses(element) {
    element.classList.forEach((cls) => {
      if (cls.startsWith("font-")) {
        element.classList.remove(cls);
      }
    });
  }

  // Utility to convert font name to class-safe format
  function fontNameToClass(fontName) {
    return `font-${fontName.toLowerCase().replace(/\s+/g, '')}`;
  }

  // Handle name input
  if (nameInput) {
    nameInput.addEventListener("input", (e) => {
      const colorInput = document.querySelector(".color-inputs-wrapper.active");
      
      document.querySelectorAll(".customization-text").forEach((text) => {
        const textSpan = text.querySelector('.customization-preview-text') || text;
        textSpan.innerHTML = e.target.value;

        const previewLogo = text.querySelector('.customization-preview-logo');
        if (previewLogo) {
          previewLogo.classList.remove('hidden');
        }

        if (e.target.value.length > 0 || previewLogo) {
          text.classList.remove("hidden");
        } else {
          text.classList.add("hidden");
        }

        text.style.position = "absolute";
        text.style.top = text.dataset.top
          ? `${text.dataset.top}%`
          : "0px";
        text.style.left = text.dataset.left
          ? `${text.dataset.left}%`
          : "0px";

        text.style.color = colorInput
          ? colorInput.dataset.activeColorHex
          : "white";

        if (fontFamilyInput) {
          const selectedFontFamily = fontFamilyInput.dataset.value || "avenir";
          removeExistingFontClasses(text);
          text.classList.add(fontNameToClass(selectedFontFamily));
        }
      });
    });
  }

  // Handle font change
  if (fontFamilyInput) {
    fontFamilyInput.addEventListener("change", (e) => {
      const selectedFontFamily = e.target.value;
      e.target.dataset.value = selectedFontFamily;

      document.querySelectorAll(".customization-text").forEach((text) => {
        const textSpanEl = text.querySelector('.customization-preview-text') || text;
        if (textSpanEl && textSpanEl.innerHTML.trim() !== "") {
          removeExistingFontClasses(text);
          text.classList.add(fontNameToClass(selectedFontFamily));
        }
      });
    });
  }

});

// Custom slider for customization popup
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('[data-custom-slider]');
  if (!slider) return;

  const track = slider.querySelector('[data-custom-track]');
  const slides = track.querySelectorAll('.custom-slider__slide');
  const nextBtn = slider.querySelector('[data-custom-next]');
  const prevBtn = slider.querySelector('[data-custom-prev]');
  const totalSlides = slides.length;

  let currentIndex = 0;

  function updateSliderVisibility(index) {
    const activeType = document.querySelector(".customization-type.active")?.dataset.customizationType;
    if (!activeType) return;

    if (index !== 0) {
      if (activeType === "name") {
        document.querySelectorAll(".customization-text").forEach((text) => text.classList.add("hidden"));
      } else if (activeType === "logo") {
        document.querySelectorAll(".customization-logo").forEach((logo) => logo.classList.add("hidden"));
      }
    } else {
      if (activeType === "name") {
        document.querySelectorAll(".customization-text").forEach((text) => {
          const textSpan = text.querySelector(".customization-preview-text") || text;
          const hasPreviewLogo = text.querySelector('.customization-preview-logo') !== null;
          if (hasPreviewLogo || (textSpan && textSpan.innerHTML.trim() !== "")) {
            text.classList.remove("hidden");
          }
        });
      } else if (activeType === "logo") {
        document.querySelectorAll(".customization-logo").forEach((logo) => logo.classList.remove("hidden"));
      }
    }
  }

  function scrollToIndex(index) {
    const slide = slides[index];
    if (!slide) return;

    const scrollPosition = slide.offsetLeft - track.offsetLeft;

    track.scrollTo({
      left: scrollPosition,
      behavior: 'smooth',
    });
  }

  nextBtn.addEventListener('click', () => {
    if (currentIndex < totalSlides - 1) {
      currentIndex++;
      scrollToIndex(currentIndex);
      updateSliderVisibility(currentIndex);
    }
  });

  prevBtn.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      scrollToIndex(currentIndex);
      updateSliderVisibility(currentIndex);
    }
  });

  track.addEventListener('scroll', () => {
    const scrollLeft = track.scrollLeft;
    const slideWidth = slides[0].offsetWidth;
    if (slideWidth === 0) return;
    currentIndex = Math.round(scrollLeft / slideWidth);
    updateSliderVisibility(currentIndex);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const customizationATCButton = document.querySelector(".customization-atc.proxy-atc-button");

  if (customizationATCButton) {
    customizationATCButton.addEventListener("click", async (e) => {
      e.preventDefault();
      showLoader(customizationATCButton);
      const cartDrawer = document.querySelector("cart-drawer");
      const proxyButton = customizationATCButton;
      const mainProductId = proxyButton.dataset.mainProductId;
      const customizationProductId = proxyButton.dataset.customizationProductId;
      const mainTitle = proxyButton.dataset.mainTitle;
      const customizationType = document.querySelector(".customization-content:not(.hidden)")?.dataset.customizationType;
      const timestamp = `${Date.now()}`;
      const isB2B = proxyButton.dataset.isB2b === "true";
      const printKey = isB2B ? "_print_type" : "print_type";

      const activeColorWrapper = document.querySelector(".color-inputs-wrapper.active");
      const color = activeColorWrapper?.querySelector(".color-name")?.innerHTML || "white";

      let propertiesMain = {
        _bundle_type: "main",
        _mainProductId: mainProductId,
        _unique_id: timestamp,
      };

      let propertiesCustom = {
        _bundle_type: "customization",
        _bundle_parent: mainTitle,
        customizationType,
        _customizationProductId: customizationProductId,
        _unique_id: timestamp,
      };

      if (customizationType === "name") {
        const nameInput = document.querySelector("input[name=name]");
        const printType = document.querySelector(".print-type")?.value || "print";
        const fontFamily = document.querySelector(".font-family")?.value || "avenir";

        propertiesCustom["name"] = nameInput?.value || "";
        propertiesCustom["color"] = color;
        propertiesCustom[printKey] = printType;
        propertiesCustom["font_family"] = fontFamily;
      } else {
        const printType = document.querySelector(".print-type.logo-type")?.value;
        propertiesCustom["logo"] = "Brand Logo";
        propertiesCustom["color"] = color;
        propertiesCustom[printKey] = printType;
      }

      const itemsToAdd = [
        {
          id: customizationProductId,
          quantity: 1,
          properties: propertiesCustom,
        },
        {
          id: mainProductId,
          quantity: 1,
          properties: propertiesMain,
        }
      ];


      // const sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id);
      const formData = {
        items: itemsToAdd,
        // sections: sectionsToRender,
      };

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const nameInput = document.querySelector("input[name=name]");

        const resetCustomizationText = (el) => {
          if (!el) return;
          const textSpan = el.querySelector('.customization-preview-text') || el;
          textSpan.innerHTML = "";
          const previewLogo = el.querySelector('.customization-preview-logo');
          if (previewLogo) {
            previewLogo.classList.remove('hidden');
          } else {
            el.classList.add('hidden');
          }
        };

        const resetAllCustomizationTexts = () => {
          document.querySelectorAll(".customization-text").forEach(resetCustomizationText);
        };

        if (res.ok) {
          const data = await res.json();
          // cartDrawer.renderContents(data);
          document.querySelector(".customization-modal")?.removeAttribute("open");
          document.body.classList.remove("overflow-hidden");
          hideLoader(customizationATCButton);
          if (nameInput) nameInput.value = "";
          resetAllCustomizationTexts();
        } else {
          const err = await res.json();
          alert(err.description || "Something went wrong");
          hideLoader(customizationATCButton);
          if (nameInput) nameInput.value = "";
          resetAllCustomizationTexts();
        }
      } catch (error) {
        console.error("Fetch error:", error);
        alert("Network error. Please try again.");
        hideLoader(customizationATCButton);
        const nameInput = document.querySelector("input[name=name]");
        if (nameInput) nameInput.value = "";
        resetAllCustomizationTexts();
      }
    });
  }
});


document.addEventListener('DOMContentLoaded', () => {
  const fabricItems = document.querySelectorAll('.fabric-item');
  if (fabricItems) {
    fabricItems.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const targetSection = document.getElementById(targetId);
        window.scrollTo({
          top: targetSection.offsetTop,
          behavior: 'smooth',
        });
      });
    });
  }

})

document.addEventListener('DOMContentLoaded', () => {
  const tabHeadings = document.querySelectorAll(".tab-button");
  const activeHeading = document.querySelector(".tab-button.active");
  const qnaBlocks = document.querySelectorAll(".tab-heading-blocks");
  const showAllButton = document.querySelector(".tab-button.all");

  if (showAllButton) {
    qnaBlocks.forEach((block) => {
      block.classList.remove("hidden");
      block.classList.add("active");
    })
  }

  if (activeHeading) {
    qnaBlocks.forEach((block) => {
      if (block.dataset.id == activeHeading.dataset.id) {
        block.classList.remove("hidden");
        block.classList.add("active");
      }
    })
  }
  if (tabHeadings && qnaBlocks) {
    tabHeadings.forEach(button => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        tabHeadings.forEach((button) => button.classList.remove("active"))
        button.classList.add("active")
        qnaBlocks.forEach((block) => {
          if (button.classList.contains("all")) {
            block.classList.add("active");
            block.classList.remove("hidden");
          } else {
            if (block.dataset.id == button.dataset.id) {
              block.classList.add("active");
              block.classList.remove("hidden");
            } else {
              block.classList.remove("active");
              block.classList.add("hidden");
            }
          }

        });

      })
    });
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const tabHeadings = document.querySelectorAll(".tab-heading");
  const tabContents = document.querySelectorAll(".tab-content");
  if (tabHeadings) {
    tabHeadings.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        tabHeadings.forEach((btn) => btn.classList.remove("active"));
        tab.classList.add("active");
        tabContents.forEach((tabContent) => {
          if (tabContent.dataset.tabHeading.trim() == tab.textContent.trim()) {
            tabContent.classList.remove("hidden");
            tabContent.classList.add("active");
          } else {
            tabContent.classList.remove("active");
            tabContent.classList.add("hidden");
          }
        })
      })
    })
  }
})

// Toggle the variants visibility.
document.addEventListener('DOMContentLoaded',() => {
  const variantToggleButton = document.querySelector(".hide-show-variants");
  const sizeVariantButtons = document.querySelectorAll(".tooltip-container")
  if (variantToggleButton) {
    variantToggleButton.addEventListener('click',(e) => {
      e.preventDefault();
      variantToggleButton.querySelector(".hide-sizes").classList.toggle("hidden");
      variantToggleButton.querySelector(".show-sizes").classList.toggle("hidden");
      sizeVariantButtons.forEach((btn) => {
        if (btn.classList.contains("target-variant")) {

          btn.classList.toggle("hidden")
        }
      })
    })
  }
})